.ButtonsContainer {
    position: absolute;
    right: 20px;
    gap: .5rem;
}

.HeaderButton {
    border-radius: 8px;
    padding-left: .5rem;
    padding-right: .5rem;
}

.InternetCheckbox {
    padding-top: .4rem;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


.Spinner {
    animation: spin 1s linear infinite;
    width: 22px;
    height: 22px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.DocumentButtonText {
    display: block;
    line-height: 100%;
    margin: 0px 4px;
    font-weight: 600;
}
